import { BrowserType } from './enums';

export const EMAIL_FIELD_DEFAULT_ATTRIBUTES = {
  type: 'email',
  inputMode: 'email',
  autoComplete: 'email',
} as const;

export const SUPPORTED_BROWSERS_FOR_AUTO_REDIRECT = [
  BrowserType.TWA,
  BrowserType.CCT,
  BrowserType.SFSVC,
];
